import { serviceName } from '../resources/serviceConstants';
import { FETCH_PROPERTY_TYPE, FETCH_WATER_SOURCE, FETCH_ROAD_TYPE, FETCH_CRZ_TYPE} from '../resources/endPoint';

export const fetchPropertyType = () => {
  return {
    url: FETCH_PROPERTY_TYPE,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: serviceName.PROJECT_MS,
  };
};
export const fetchWaterSource = () => {
  return {
    url: FETCH_WATER_SOURCE,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: serviceName.PROJECT_MS,
  };
};

export const fetchRoadType = () => {
  return {
    url: FETCH_ROAD_TYPE,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: serviceName.PROJECT_MS,
  };
};
export const fetchCRZType = () => {
  return {
    url: FETCH_CRZ_TYPE,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: serviceName.PROJECT_MS,
  };
};

